import { useNavigate } from "react-router-dom";

/**
 * 삭제된 매장의 상세 페이지에서 노출되는 모달
 */
export const StoreDeletedModal = ({ isOpen }: { isOpen: boolean }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-[350px] mx-4">
        <div className="text-center">
          <div className="text-5xl mb-3">😲</div>
          <h2 className="font-bold text-3xl text-black mb-6 break-keep">
            앗! 아쉽지만 이 매장은 <br /> 더 이상 운영을 하지 않아요
          </h2>
          <button
            onClick={() => navigate("/")}
            className="w-full bg-blue-500 text-white font-bold text-lg px-6 py-3 rounded-lg"
          >
            홈으로 돌아가기
          </button>
        </div>
      </div>
    </div>
  );
};
